
































import { Component } from 'vue-property-decorator'
import PostType from '~components/content/post-types/PostType.vue'
import PostTitle from '~components/content/PostTitle.vue'
import LazyPicture from '~components/utils/LazyPicture.vue'

@Component({
  components: {
    PostTitle,
    LazyPicture,
  },
})
export default class RegularWithExcerpt extends PostType {
  get excerpt() {
    if (this.post.excerpt) {
      return this.post.excerpt
    } else if (this.post.leadText) {
      return this.post.leadText
    } else if (this.post.blocks && this.post.blocks.length > 0) {
      return this.post.blocks.find((b) => b.ot === 'core/paragraph')?.h
    }
    return ''
  }
}
